// Single source of truth for API paths. The Vite dev server proxies the
// /dm/V1 prefix to the local DealManagement API (see vite.config.ts).
export const APIS = {
  Deals: "/dm/V1/deals",
  HealthCheck: "/dm/V1/healthcheck",
  Links: "/dm/V1/links",
  CurrentUser: "/dm/V1/users/me",
  // Dev-only: returns the mock-user roster the API will accept via the
  // X-Impersonate-User header. The endpoint is env-guarded server-side
  // (404 outside Development). See src/auth/ImpersonationSwitcher.tsx.
  DevImpersonations: "/dm/V1/users/dev/available-impersonations",
} as const;

export const PAGE_SIZE_DEFAULT = 25;

// localStorage key + axios header name used by the dev impersonation
// switcher. Reading/writing these in one place avoids drift between the
// dropdown component and the axios interceptor.
export const IMPERSONATION_STORAGE_KEY = "dm-impersonate";
export const IMPERSONATION_HEADER = "X-Impersonate-User";
